angular.module('tasksPm', ['pb.core']).run([
  '$filter',
  'Module',
  function($filter, Module) {
    new Module().push({
      menu: {
        name: 'tasksPm',
        title: $filter('translate')('tasksPm.TITLE'),
        icon: 'zmdi zmdi-assignment-check',
        link: 'root.app.simple.tasksPm'
      }
    });
  }
]);
